/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ReferralCode } from './ReferralCode';
import {
    ReferralCodeFromJSON,
    ReferralCodeFromJSONTyped,
    ReferralCodeToJSON,
    ReferralCodeToJSONTyped,
} from './ReferralCode';

/**
 * 
 * @export
 * @interface GetChallengeSlugOwnReferralCodeResponse
 */
export interface GetChallengeSlugOwnReferralCodeResponse {
    /**
     * 
     * @type {ReferralCode}
     * @memberof GetChallengeSlugOwnReferralCodeResponse
     */
    referralCode: ReferralCode;
}

/**
 * Check if a given object implements the GetChallengeSlugOwnReferralCodeResponse interface.
 */
export function instanceOfGetChallengeSlugOwnReferralCodeResponse(value: object): value is GetChallengeSlugOwnReferralCodeResponse {
    if (!('referralCode' in value) || value['referralCode'] === undefined) return false;
    return true;
}

export function GetChallengeSlugOwnReferralCodeResponseFromJSON(json: any): GetChallengeSlugOwnReferralCodeResponse {
    return GetChallengeSlugOwnReferralCodeResponseFromJSONTyped(json, false);
}

export function GetChallengeSlugOwnReferralCodeResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetChallengeSlugOwnReferralCodeResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'referralCode': ReferralCodeFromJSON(json['referralCode']),
    };
}

export function GetChallengeSlugOwnReferralCodeResponseToJSON(json: any): GetChallengeSlugOwnReferralCodeResponse {
    return GetChallengeSlugOwnReferralCodeResponseToJSONTyped(json, false);
}

export function GetChallengeSlugOwnReferralCodeResponseToJSONTyped(value?: GetChallengeSlugOwnReferralCodeResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'referralCode': ReferralCodeToJSON(value['referralCode']),
    };
}

